/**
 * My Accounts' reorder with unmanaged accounts hidden (TMMAPP-0120 item 19). The grid reorders only
 * the cards it shows, but tmm-api wants the type's full id list (else 409 `REORDER_SET_MISMATCH`).
 * Each hidden id keeps its place after the same shown id it followed before; a hidden id with no
 * shown id before it stays at the start. Ids in `visible` that `previous` lacks are kept, in order.
 */
export function mergeHiddenOrder<Id extends string | number>(
  previous: readonly Id[],
  visible: readonly Id[],
): Id[] {
  const shown = new Set(visible.map(String));
  const leading: Id[] = [];
  const after = new Map<string, Id[]>();
  let anchor: string | null = null;
  for (const id of previous) {
    const key = String(id);
    if (shown.has(key)) {
      anchor = key;
      continue;
    }
    if (anchor === null) {
      leading.push(id);
    } else {
      const list = after.get(anchor) ?? [];
      list.push(id);
      after.set(anchor, list);
    }
  }
  return [...leading, ...visible.flatMap((id) => [id, ...(after.get(String(id)) ?? [])])];
}
